import { PensPane } from 'features/timeSeries/components/panes/PensPane'
import { TagBrowserPane } from 'features/timeSeries/components/panes/TagBrowserPane'
import { TagConfigurationPane } from 'features/timeSeries/components/panes/TagConfigurationPane'
import React, { useState } from 'react'
import styled from 'styled-components'

/* Below this chart-area width the rails float over the plot instead of
   squeezing it, so a rail in a narrow host keeps the chart readable. */
const RAIL_OVERLAY_BREAKPOINT = '56rem'

const Rail = styled.aside<{ $side: 'left' | 'right'; $width: string }>`
  display: flex;
  flex-direction: column;
  flex: 0 0 ${({ $width }) => $width};
  min-height: 0;
  overflow: hidden;
  background: var(--background);
  color: var(--foreground);
  ${({ $side }) => ($side === 'left' ? 'border-right' : 'border-left')}: 1px
    solid var(--border);

  @container chartArea (max-width: ${RAIL_OVERLAY_BREAKPOINT}) {
    position: absolute;
    top: 0;
    bottom: 0;
    ${({ $side }) => $side}: 0;
    width: min(${({ $width }) => $width}, 100%);
    z-index: 5;
    box-shadow:
      0 0 0 1px var(--border),
      0 8px 24px rgb(0 0 0 / 0.45);
  }
`

/** Tags browser + tag configuration, stacked like the workbench's left rail. */
export const EmbeddedLeftRail: React.FC = () => (
  <Rail $side='left' $width='17.5rem'>
    <TagBrowserPane />
    <TagConfigurationPane grow />
  </Rail>
)

/** Selected Tags with live cursor values, the workbench's right rail. */
export const EmbeddedRightRail: React.FC = () => {
  const [showDescriptions, setShowDescriptions] = useState(true)
  return (
    <Rail $side='right' $width='16.25rem'>
      <PensPane
        grow
        showDescriptions={showDescriptions}
        onToggleDescriptions={() => setShowDescriptions((current) => !current)}
      />
    </Rail>
  )
}
